import { SET_MONTH_STATS, CLEAR_MONTH_STATS } from '../types'

export const setMonthStats = (data) => ({
    type: SET_MONTH_STATS,
    payload: data
})

export const clearMonthStats = () => ({
    type: CLEAR_MONTH_STATS
})
